import Vue from 'vue'

const requireComponent = require.context(
  '@/components',
  false,
  /[A-Z]\w+\.vue$/
)

requireComponent.keys().forEach(file => {
  const componentName = file.split('/').pop().replace(/\.\w+$/, '');
  const componentConfig = requireComponent(file);
  Vue.component(componentName, componentConfig.default || componentConfig);
})
